import React from 'react'

import './Alert.css'

export function Alert({ color , children }) {

    let className = ['alert']
    if(color) className.push(`alert-${color}`);
    
    className = className.join(' ')
    return (
        <div className={className}>{ children }</div>
    )
}
